export default __webpack_public_path__ + "static/media/templateOptionTwo.37acc0b2.png";